module.exports = __webpack_public_path__ + "static/img/restaurant-view-tabs01.fd149354.svg";